import RoleDetailComponent from './component';

class RoleDetailRoute extends RoleDetailComponent {
}

export default RoleDetailRoute;
